import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-78a47ae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "yt-shell" }
const _hoisted_2 = { class: "yt-header" }
const _hoisted_3 = { class: "yt-header__inner" }
const _hoisted_4 = { class: "yt-header__left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-bars" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "yt-brand__mark",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-play" })
], -1))
const _hoisted_8 = { class: "yt-brand__name" }
const _hoisted_9 = { class: "yt-brand__region" }
const _hoisted_10 = { class: "yt-header__center" }
const _hoisted_11 = { class: "yt-header__right" }
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1))
const _hoisted_14 = { class: "yt-create__label" }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-house-circle-check" }, null, -1))
const _hoisted_17 = { class: "yt-create__label" }
const _hoisted_18 = ["title"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-coins",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_20 = { class: "yt-points-chip__full" }
const _hoisted_21 = { class: "yt-points-chip__compact" }
const _hoisted_22 = ["title"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-bell" }, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "yt-notif-btn__dot",
  "aria-hidden": "true"
}
const _hoisted_25 = ["title"]
const _hoisted_26 = ["title"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-regular fa-circle-user",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_28 = { class: "yt-signin__label" }

import { ref, computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCookies } from 'vue3-cookies'
import { STORE_INFORMATION, DEFAULT_MENU_HEADER } from '@/const/ApiRedis'
import { apiRedis } from '@/api/index'
import Drawer from '@/components/ant/drawer/Drawer.vue'
import MenuMobile from '@/components/Headers/default/menu/MenuMobile.vue'
import MegaMenu from '@/components/Headers/default/menu/MegaMenu.vue'
import HeaderSearch from '@/components/Headers/default/component/Search.vue'
import PageBanner from '@/components/ant/pagebaner/PageBanner.vue'
import DefaultBreadcrumb from '@/components/ant/breadcrumb/DefaultBreadcrumb.vue'
import DrawerCustomer from '@/components/Headers/default/customer/DrawerCustomer.vue'
import DrawerNotification from '@/components/Headers/default/customer/DrawerNotification.vue'
import GuestMoreMenu from '@/components/Headers/default/customer/GuestMoreMenu.vue'
import commons from '@/utils/Common'
import router from '@/router'
import store from '@/store'
import { LANGUAGE, DEFAULT } from '@/const/language'
import { HOME, LOGIN, userProfilePath, ROOM_MANAGER, CUSTOMER_POST_NEWS, LOYALTY_POINTS } from '@/const/path'
import axios from 'axios'
import { useLoyaltyPoints } from '@/composables/useLoyaltyPoints'


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultHeader',
  setup(__props) {

const { locale } = useI18n()
const { cookies } = useCookies()
const {
  balanceFull,
  balanceCompact,
  refresh: refreshPoints,
  fetchBalance: fetchPoints,
  connectSse,
  disconnectSse,
} = useLoyaltyPoints()

const menuDefault: any = ref([])
const companys: any = ref({})
const showMenu = ref(false)
const showNotifDrawer = ref(false)
const hasUnreadNotifications = ref(false)
const showMegaMenu = ref(false)
const megaMenu: any = ref([])
const isLogin = ref(false)
const showUserDrawer = ref(false)
const userTagName = ref('')
let megaTimer: ReturnType<typeof setTimeout> | null = null

const brandName = computed(
  () => companys.value?.subName || companys.value?.name || 'Kima Home'
)

const companyHotline = computed(
  () =>
    String(
      companys.value?.phone ||
        companys.value?.hotline ||
        companys.value?.mobile ||
        ''
    ).trim()
)

const langLabelShort = computed(() =>
  ((locale.value || cookies.get(LANGUAGE) || DEFAULT) === 'us' ? 'EN' : 'VN')
)

const guestLocationLabel = computed(() =>
  locale.value === 'us' ? 'Vietnam' : 'Việt Nam'
)

const avatarInitial = computed(() => {
  const name = (userTagName.value || 'H').trim()
  return name.charAt(0).toUpperCase() || 'H'
})

const openNotifDrawer = () => {
  refreshLogin()
  if (!isLogin.value) {
    router.push({ path: LOGIN }).catch(() => undefined)
    return
  }
  showNotifDrawer.value = true
}

const refreshLogin = () => {
  isLogin.value = !!commons.checkLogin()
  const user = commons.getUserData()
  userTagName.value = user?.tagName || user?.name || user?.username || ''
  if (isLogin.value) {
    refreshPoints()
    void fetchPoints()
    connectSse()
  } else {
    disconnectSse()
  }
}

const goLoyaltyPoints = () => {
  router.push({ path: LOYALTY_POINTS }).catch(() => undefined)
}

const loadMenuDefault = async () => {
  try {
    const res: any = await apiRedis(DEFAULT_MENU_HEADER)
    let data = res?.data?.data
    if (typeof data === 'string') data = JSON.parse(data)
    menuDefault.value = data || []
  } catch {
    menuDefault.value = []
  }
}

const loadCompanyInform = async () => {
  try {
    commons.ensureTenant()
    const res: any = await apiRedis(STORE_INFORMATION)
    const data = JSON.parse(res.data.data)
    const companyInfor = data[0]
    commons.setCokiesCompany(companyInfor)
    companys.value = companyInfor
  } catch {
    companys.value = commons.getCokiesCompany() || {}
  }
}

const showDrawer = () => {
  showMenu.value = true
}
const closePopup = (val: any) => {
  showMenu.value = val
}

const openUserDrawer = () => {
  showUserDrawer.value = true
}

const goLogin = () => router.push({ path: LOGIN })

const goPostNews = () => {
  refreshLogin()
  if (!isLogin.value) {
    router.push({ path: LOGIN })
    return
  }
  router.push({ path: CUSTOMER_POST_NEWS }).catch(() => undefined)
}

const goRooms = () => {
  refreshLogin()
  if (!isLogin.value) {
    router.push({ path: LOGIN })
    return
  }
  router.push({ path: ROOM_MANAGER }).catch(() => undefined)
}

const keepMega = () => {
  if (megaTimer) clearTimeout(megaTimer)
  showMegaMenu.value = true
}
const hideMega = () => {
  megaTimer = setTimeout(() => {
    showMegaMenu.value = false
  }, 180)
}

const setLang = (next: 'vn' | 'us') => {
  const current = locale.value || cookies.get(LANGUAGE) || DEFAULT
  if (current === next) return
  store.dispatch('setCountryChange', next)
  localStorage.setItem(LANGUAGE, next)
  cookies.set(LANGUAGE, next)
  locale.value = next
  axios.defaults.headers.common['Accept-Language'] = next
  loadMenuDefault()
}

const toggleLang = () => {
  const current = locale.value || cookies.get(LANGUAGE) || DEFAULT
  setLang(current === 'vn' ? 'us' : 'vn')
}

const isLoadLogin = computed(() => store.getters.isLoadLogin)
watch(isLoadLogin, () => refreshLogin())

onMounted(async () => {
  await loadMenuDefault()
  await loadCompanyInform()
  refreshLogin()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "yt-icon-btn",
            "aria-label": "Menu",
            onClick: showDrawer
          }, _hoisted_6),
          _createVNode(_component_router_link, {
            to: _unref(HOME),
            class: "yt-brand"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(brandName.value), 1),
              _createElementVNode("sup", _hoisted_9, _toDisplayString(langLabelShort.value), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(HeaderSearch)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "yt-create",
            title: _ctx.$t('header.create'),
            onClick: goPostNews
          }, [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('header.create')), 1)
          ], 8, _hoisted_12),
          _createElementVNode("button", {
            type: "button",
            class: "yt-room",
            title: _ctx.$t('header.manageRooms'),
            onClick: goRooms
          }, [
            _hoisted_16,
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('header.manageRooms')), 1)
          ], 8, _hoisted_15),
          (isLogin.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "yt-points-chip",
                  title: _ctx.$t('header.pointsBalance', { points: _unref(balanceFull) }),
                  onClick: goLoyaltyPoints
                }, [
                  _hoisted_19,
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(balanceFull)), 1),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(balanceCompact)), 1)
                ], 8, _hoisted_18),
                _createElementVNode("button", {
                  type: "button",
                  class: "yt-icon-btn yt-notif-btn",
                  title: _ctx.$t('header.notifications'),
                  onClick: openNotifDrawer
                }, [
                  _hoisted_23,
                  (hasUnreadNotifications.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_22),
                _createElementVNode("button", {
                  type: "button",
                  class: "yt-avatar",
                  title: userTagName.value || _ctx.$t('header.account'),
                  onClick: openUserDrawer
                }, _toDisplayString(avatarInitial.value), 9, _hoisted_25)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(GuestMoreMenu, {
                  "lang-code": _unref(locale),
                  "location-label": guestLocationLabel.value,
                  onChangeLang: setLang
                }, null, 8, ["lang-code", "location-label"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "yt-signin",
                  title: _ctx.$t('loginForm.login'),
                  onClick: goLogin
                }, [
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('loginForm.login')), 1)
                ], 8, _hoisted_26)
              ], 64))
        ])
      ]),
      (showMegaMenu.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "yt-mega",
            onMouseenter: keepMega,
            onMouseleave: hideMega
          }, [
            _createVNode(MegaMenu, { "mega-menu": megaMenu.value }, null, 8, ["mega-menu"])
          ], 32))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Drawer, {
      placement: "left",
      "show-form": showMenu.value,
      onClosePopup: closePopup
    }, {
      content: _withCtx(() => [
        _createVNode(MenuMobile, {
          "data-menu": menuDefault.value,
          "is-login": isLogin.value,
          "user-tag-name": userTagName.value,
          "has-unread": hasUnreadNotifications.value,
          "lang-label-short": langLabelShort.value,
          hotline: companyHotline.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (closePopup(false))),
          onOpenNotifications: openNotifDrawer,
          onOpenAccount: openUserDrawer,
          onToggleLang: toggleLang,
          onChangeLang: setLang,
          onLoggedOut: refreshLogin
        }, null, 8, ["data-menu", "is-login", "user-tag-name", "has-unread", "lang-label-short", "hotline"])
      ]),
      _: 1
    }, 8, ["show-form"]),
    _createVNode(DrawerCustomer, {
      open: showUserDrawer.value,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((showUserDrawer).value = $event)),
      "user-tag-name": userTagName.value,
      onLoggedOut: refreshLogin
    }, null, 8, ["open", "user-tag-name"]),
    _createVNode(DrawerNotification, {
      open: showNotifDrawer.value,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((showNotifDrawer).value = $event)),
      "has-unread": hasUnreadNotifications.value,
      "onUpdate:hasUnread": _cache[3] || (_cache[3] = ($event: any) => ((hasUnreadNotifications).value = $event)),
      "is-login": isLogin.value,
      onRequireLogin: goLogin
    }, null, 8, ["open", "has-unread", "is-login"]),
    _createVNode(PageBanner)
  ]))
}
}

})